module.exports = __webpack_public_path__ + "img/f.71281f7f.jpg";